<script lang="ts">

	import {createEventDispatcher} from "svelte";
    import {_} from "svelte-i18n";

	const dispatch = createEventDispatcher();

    export let name;

</script>

<div class="list-item">
   <!-- <button class="remove-button" type="button" on:click={() => dispatch('remove')}>
        Del.
    </button>
    -->
        <input  class="remove-button" type="reset" value="{$_('deleteBtn')}" aria-label="Del - Delete {name}" on:click={() => dispatch('remove')}>


    <span class="list-item-text">
        <slot></slot>
    </span>
</div>

<style lang="scss">
  $start-item-offset: 6px;
  .list-item {
    background: white;
    border: 1px solid black;
    //border-radius: 5px;
    border-radius:12px;
    padding: 10px 0;
    margin-bottom: 15px;

    .list-item-text {
      font-family: 'Open Sans', sans-serif;
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 21px;
      width: 100%;

      margin: auto 25px auto 0;
    }

    display: flex;

    .remove-button {
      all: unset;
      cursor: pointer;

      border: 1px solid black;
      border-radius: 5px;
      background: #F8B92C;

      font-family: 'Open Sans', sans-serif;
      font-size: 12px;
      font-weight: 600;
      //line-height: 12px;
      letter-spacing: 0;
      text-align: left;

      line-height: 1;
      margin: auto 15px auto 0;
      padding: 10px 2px;
      transform: translateX(-$start-item-offset);

      &:focus {
        border-color: var(--focus-color);
      }
    }

    &:focus-within {
      box-shadow: var(--btn-focus-box-shadow);
    }
  }
</style>
